import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { BrandInventoryLabelStackContentViewModel } from './brand-inventory-label-stack-content-view-model';
import { PrintLabelContentComponent } from '../../print-label-content.component';

@Component({
  selector: 'app-brand-inventory-label-stack-content',
  templateUrl: './brand-inventory-label-stack-content.component.html',
  styleUrl: './brand-inventory-label-stack-content.component.scss',
  providers: [BrandInventoryLabelStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BrandInventoryLabelStackContentComponent extends PrintLabelContentComponent {
  constructor(
    public viewModel: BrandInventoryLabelStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
